/* eslint-disable jsx-a11y/alt-text */
import { FC } from 'react'

import { Image, ImageProps } from 'components/image'
import { cn } from 'utils'

import classes from './content-image.module.css'

export const ContentImage: FC<Omit<ImageProps, 'alt'>> = ({ className, ...props }) => {
  return (
    <div className={cn(classes.imageContainer, className)}>
      <Image {...props} quality={90} alt="Image" />
    </div>
  )
}
